import { useEffect, useRef } from 'react';

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    tick();
    const id = setInterval(tick, delay);
    return () => clearInterval(id);
  }, [delay]);
}



// WEBPACK FOOTER //
// ./src/redux/opentok/hooks/useInterval.js